const HandOver = () => import('@/views/main/wechatMgmt/handOver/HandOver.vue')
export default {
  path: '/main/wechatMgmt/handOver',
  name: 'handOver',
  component: HandOver
}
